import Dashboard from "./Dashboard";
import Layout from "../../components/Layout";

export default function Home() {
  return Layout(Dashboard, "Gráficos");
}
